/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function initProductMobileDots(scope) {
    var root = scope || document;
    var products = root.querySelectorAll('product-component');

    products.forEach(function(product) {
      if (product.dataset.mobileDotsReady === 'true') return;

      var images = product.querySelector('product-images.product__images--mobile-slider');
      var slidesTrack = images && images.querySelector('[data-product-media-list]');
      var dots = product.querySelector('[data-product-mobile-dots]');
      var buttons = dots ? Array.from(dots.querySelectorAll('[data-product-mobile-dot]')) : [];
      var slides = slidesTrack ? Array.from(slidesTrack.querySelectorAll('[data-slide][data-media-id]')) : [];

      if (!images || !slidesTrack || buttons.length <= 1 || slides.length <= 1) return;

      var syncFromMediaId = function(mediaId) {
        if (!mediaId) return;

        buttons.forEach(function(button) {
          var isActive = button.getAttribute('data-media-id') === mediaId;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };

      var syncFromScroll = function() {
        if (!window.theme.isMobile()) return;

        var trackRect = slidesTrack.getBoundingClientRect();
        var trackCenter = trackRect.left + trackRect.width / 2;
        var activeSlide = slides[0];
        var closestDistance = Number.POSITIVE_INFINITY;

        slides.forEach(function(slide) {
          var rect = slide.getBoundingClientRect();
          var slideCenter = rect.left + rect.width / 2;
          var distance = Math.abs(slideCenter - trackCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            activeSlide = slide;
          }
        });

        if (!activeSlide) return;

        var mediaId = activeSlide.getAttribute('data-media-id');
        syncFromMediaId(mediaId);

        if (images.getAttribute('data-active-media') !== mediaId) {
          images.setAttribute('data-active-media', mediaId);
        }
      };

      var throttledSyncFromScroll = window.theme.throttle(syncFromScroll, 80);
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-active-media') {
            syncFromMediaId(images.getAttribute('data-active-media'));
          }
        });
      });

      observer.observe(images, { attributes: true, attributeFilter: ['data-active-media'] });

      buttons.forEach(function(button) {
        button.addEventListener('click', function() {
          var mediaId = button.getAttribute('data-media-id');
          var slide = slides.find(function(item) {
            return item.getAttribute('data-media-id') === mediaId;
          });

          if (!slide) return;

          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          syncFromMediaId(mediaId);
        });
      });

      slidesTrack.addEventListener('scroll', throttledSyncFromScroll, { passive: true });
      document.addEventListener('theme:resize:width', syncFromScroll);

      syncFromMediaId(images.getAttribute('data-active-media'));
      syncFromScroll();

      product.dataset.mobileDotsReady = 'true';
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initProductMobileDots(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initProductMobileDots(event.target);
  });

  // Search: Shopify's semantic search returns nearly the whole catalog for any
  // query. Quoting each word switches it to exact keyword matching.
  // sections/search.liquid handles direct links and the zero-result fallback.
  function toExactSearchQuery(query) {
    if (/["*:()]/.test(query)) return query;

    return query.trim().split(/\s+/).filter(Boolean).map(function(word) {
      return '"' + word + '"';
    }).join(' ');
  }

  document.addEventListener('submit', function(event) {
    var form = event.target;
    if (event.defaultPrevented || !form.matches('form[action$="/search"]')) return;

    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;

    var exactQuery = toExactSearchQuery(input.value);
    if (exactQuery === input.value) return;

    event.preventDefault();
    var params = new URLSearchParams(new FormData(form));
    params.set('q', exactQuery);
    window.location.href = form.getAttribute('action') + '?' + params.toString();
  });


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
